import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapGetters, mapState} from 'vuex'
import {checkReturnInfo, checkReturnStatus} from '../../../../../common/utils/return-message-util'
import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as ReturnMessageConstants from "../../../../../constants/ReturnMessageConstants";
export default {
  data () {
    return {
      cancelType: DictionaryConstants.COUPON_CANCELLATION,
      verifySalesAmount: '',
      btnTypeCouponCancel: 'primary',
      btnTypeCouponAndAmountCancel: ''
    }
  },
  computed: {
    ...mapState('wxMemberModule', ['qrCode']),
  },
  methods: {
    ...mapActions('wxMemberModule', ['getWXSignature', 'cancelCoupon', 'getUserInfo',
      'getCancelTypeOptions', 'emptyQrCode']),
    scanCode () {
      // 获取微信签名
      this.getWXSignature(location.href.split('#')[0])
    },
    async cancellationAfterVerification () {
      if (!this.cancelType) {
        this.$message.warning('核销类型不能为空')
        return false
      }
      if (!this.qrCode) {
        this.$message.warning('核销码不能为空')
        return false
      }
      if (this.cancelType === DictionaryConstants.COUPON_AND_SALES_AMOUNT_CANCELLATION &&
        !this.verifySalesAmount) {
        this.$message.warning('现金不能为空')
        return false
      }
      const data = {
        verifySalesType: this.cancelType,
        couponExampleCode: this.qrCode,
        verifySalesAmount: this.verifySalesAmount
      }
      const result = await this.cancelCoupon(data)
      if (result && result.data) {
        this.emptyQrCode()
        this.verifySalesAmount = ''
        this.$message.success('卡劵核销成功')
      } else{
        this.$message.warning('卡劵重复核销')
      }
    },
    async getUserContext () {
      const result = await this.getUserInfo()
      // console.log('result', result)
      // 判断当前登录人是会员还是员工
      if (result.data.itemType === 1000) {
        this.getMemberDetail()
        this.showState = true
      } else if (result.data.itemType === 1) {
        this.showState = false
      }
    },
    // 查看核销记录
    skipToCancelRecord () {
      this.$router.push({
        path: RoutePathConstants.CANCEL_RECORD
      })
    },
    couponCancel () {
      this.cancelType = DictionaryConstants.COUPON_CANCELLATION
      this.btnTypeCouponCancel = 'primary'
      this.btnTypeCouponAndAmountCancel = ''
    },
    couponAndAmountCancel () {
      this.cancelType = DictionaryConstants.COUPON_AND_SALES_AMOUNT_CANCELLATION
      this.btnTypeCouponCancel = ''
      this.btnTypeCouponAndAmountCancel = 'primary'
      this.verifySalesAmount = ''
    }
  },
  mounted () {
    this.emptyQrCode()
    // 查询字典获取核销方式
    this.getCancelTypeOptions(DictionaryConstants.CANCELLATION_AFTER_VERIFICATION_TYPE)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/write-off-operation/views/write-off-operation.js